import * as d3 from 'd3';
import moment from 'moment/moment';
import Axis from './Axis.js';

export default class UnitsYearAxis extends Axis {
  constructor(props) {
    super(props);

    this.axis = d3.axisBottom(this.xScale).ticks(d3.timeYear.every(1));
  }

  positionText() {
    const {
      chart,
      options: { width },
    } = this.props;

    chart
      .selectAll('.year .tick text')
      .attr('transform', `translate(${width / 4 / 2}, 0)`);

    return this;
  }

  setCurrentYear() {
    const { chart } = this.props;

    chart.selectAll('.year .tick text').attr('class', (value) => {
      if (moment(value, 'YYYY-MM-DD').isSame(moment(), 'years')) {
        return 'current-year';
      }
    });

    return this;
  }

  addYearGrid() {
    const {
      chart,
      options: { height },
    } = this.props;
    chart
      .selectAll('.year .tick')
      .select('line')
      .transition()
      .duration(0)
      .attr('stroke-dasharray', false)
      .attr('y2', height);

    return this;
  }

  removeDomainPath() {
    const { chart } = this.props;

    chart.select('.year .domain').remove();

    return this;
  }

  update() {
    const { chart } = this.props;

    this.axis.scale(this.xScale);

    chart
      .select('.axis.year')
      .transition()
      .duration(this.transitionDuration)
      .call(this.axis);

    this.positionText().addYearGrid().removeDomainPath().setCurrentYear();
  }

  build() {
    const { chart } = this.props;

    chart
      .append('g')
      .attr('class', 'axis year')
      .attr('transform', 'translate(0,0)')
      .call(this.axis);

    this.positionText().addYearGrid().removeDomainPath().setCurrentYear();
  }
}
